import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { theme } from 'styled-tools';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';
import get from 'lodash/get';
import { useHistory } from 'react-router-dom';
import { ErrorContext } from 'contexts/ErrorContext';
import DeleteModal from 'components/DeleteModal';

const DEFAULT_ERROR_MESSAGE = 'Something went wrong while trying to delete your learning template. Please try again.';

const DELETE_LEARNING_PATH = gql`
  mutation delete($id: ID!) {
    deleteLearningPath(id: $id) {
      success
      code
      message
    }
  }
`;

const Red = styled.span`
  color: ${theme('colors.darkRed')};
`;

function DeleteTemplateAction({ learningPathId }) {
  const { setError } = useContext(ErrorContext);
  const [isOpen, setIsOpen] = useState(false);
  const [deleteLearningPath] = useMutation(DELETE_LEARNING_PATH);
  const { push: redirectTo } = useHistory();

  const toggle = () => setIsOpen(!isOpen);

  const onDeleteClick = async () => {
    setError(null);
    toggle();

    try {
      const { data } = await deleteLearningPath({ variables: { id: learningPathId } });

      if (get(data, 'deleteLearningPath.success')) {
        redirectTo('/engage-admin', { alert: { type: 'success', message: 'Learning template deleted' } });
      } else {
        setError(get(data, 'deleteLearningPath.message', DEFAULT_ERROR_MESSAGE));
      }
    } catch (e) {
      setError(DEFAULT_ERROR_MESSAGE);
    }
  };

  return (
    <DeleteModal
      title='Delete Template'
      message={
        <>
          Are you sure you would like to <Red>delete</Red> this template?
        </>
      }
      action={onDeleteClick}
      buttonLabel='Delete Template'
    />
  );
}

DeleteTemplateAction.propTypes = {
  learningPathId: PropTypes.string.isRequired,
};

export default DeleteTemplateAction;
